import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { Image } from "react-bootstrap";
import Logo from '../../../assets/full_logo.png'
import './LandingHeader.css'

interface LandingHeaderState {
  
}
class LandingHeader extends React.Component<LandingHeaderState> {
  constructor(props: any) {
    super(props);

    this.state = {
      
    }
  }

  render() {
    return (
        <Navbar expand="lg" variant="dark">
          <Navbar.Brand>
            <Image width={150} src={Logo} fluid />
          </Navbar.Brand>
        </Navbar>
    );
  }
}

export default LandingHeader;
